export default __webpack_public_path__ + "static/media/nuvama-logo.d613690f.svg";